"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _TabHeader = _interopRequireDefault(require("./TabHeader.style"));
var _StyledPillContainer = _interopRequireDefault(require("./StyledPillContainer.style"));
var _StyledSplashContainer = _interopRequireDefault(require("./StyledSplashContainer.style"));
var _StyledClassicContainer = _interopRequireDefault(require("./StyledClassicContainer.style"));
var _constants = require("../constants");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var STYLED_MAP = _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, _constants.VIEW_TYPE["default"], _TabHeader["default"]), _constants.VIEW_TYPE.pill, _StyledPillContainer["default"]), _constants.VIEW_TYPE.splash, _StyledSplashContainer["default"]), _constants.VIEW_TYPE.classic, _StyledClassicContainer["default"]);
var TabHeader = function TabHeader(_ref) {
  var view = _ref.view,
    alignment = _ref.alignment,
    noMargins = _ref.noMargins,
    children = _ref.children,
    isWizzard = _ref.isWizzard,
    controllable = _ref.controllable;
  var StyledComponent = STYLED_MAP[view] || _TabHeader["default"];
  return /*#__PURE__*/_react["default"].createElement(StyledComponent, {
    alignment: alignment,
    noMargins: noMargins,
    view: view,
    isWizzard: isWizzard,
    controllable: controllable,
    className: "tab-headers headers-".concat(view)
  }, children);
};
TabHeader.defaultProps = {
  noMargins: false,
  isWizzard: false,
  controllable: false
};
TabHeader.propTypes = {
  isWizzard: _propTypes["default"].bool,
  controllable: _propTypes["default"].bool,
  view: _propTypes["default"].string.isRequired,
  alignment: _propTypes["default"].string.isRequired,
  noMargins: _propTypes["default"].bool,
  children: _propTypes["default"].node.isRequired
};
var _default = exports["default"] = TabHeader;